import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-slate-900 text-white py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8 mb-8">
          <div>
            <Link to="/" className="flex items-center space-x-2 mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_discount-finder-55/artifacts/kl5rg4yh_ic_launcher.png" 
                alt="Peterhahn Fashion Coupon Club" 
                className="w-8 h-8 object-contain"
              />
              <span className="text-lg font-bold text-white">
                Peterhahn Fashion Coupon Club
              </span>
            </Link>
            <p className="text-slate-400 text-sm">
              Your trusted source for the best coupon codes and deals from thousands of stores.
            </p>
          </div>
          
          <div>
            <h4 className="font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2 text-sm text-slate-400">
              <li>
                <Link to="/" className="hover:text-white transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/stores" className="hover:text-white transition-colors">
                  All Stores
                </Link>
              </li>
              <li>
                <Link to="/about" className="hover:text-white transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-white transition-colors">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-semibold mb-4">Legal</h4>
            <ul className="space-y-2 text-sm text-slate-400">
              <li>
                <Link to="/privacy" className="hover:text-white transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="hover:text-white transition-colors">
                  Terms of Service
                </Link>
              </li>
            </ul>
            <h4 className="font-semibold mb-2 mt-4">Contact Us</h4>
            <a 
              href="mailto:tb930654@gmail.com" 
              className="text-sm text-slate-400 hover:text-white transition-colors"
            >
              tb930654@gmail.com
            </a>
          </div>
          
          <div>
            <h4 className="font-semibold mb-4">Popular Stores</h4>
            <ul className="space-y-2 text-sm text-slate-400">
              <li>
                <Link to="/search?q=nike" className="hover:text-white transition-colors">
                  Nike Coupons
                </Link>
              </li>
              <li>
                <Link to="/search?q=amazon" className="hover:text-white transition-colors">
                  Amazon Deals
                </Link>
              </li>
              <li>
                <Link to="/search?q=adidas" className="hover:text-white transition-colors">
                  Adidas Codes
                </Link>
              </li>
              <li>
                <Link to="/search?q=target" className="hover:text-white transition-colors">
                  Target Savings
                </Link>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-slate-800 pt-8">
          <div className="flex flex-col sm:flex-row justify-between items-center space-y-4 sm:space-y-0">
            <p className="text-slate-400 text-sm text-center sm:text-left">
              © 2025 Peterhahn Fashion Coupon Club. All rights reserved.
            </p>
            <div className="flex space-x-6 text-sm text-slate-400">
              <Link to="/privacy" className="hover:text-white transition-colors">
                Privacy Policy
              </Link>
              <Link to="/terms" className="hover:text-white transition-colors">
                Terms
              </Link>
              <Link to="/contact" className="hover:text-white transition-colors">
                Contact
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
